// Back to top button function
(function() {
  const scrollToTopBtn = document.createElement('button');
  scrollToTopBtn.id = 'scroll-to-top-btn';
  scrollToTopBtn.setAttribute('aria-label', 'Back to top');
  scrollToTopBtn.innerHTML = '<svg class="icon icon-caret" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"></path></svg>';
  
  document.body.appendChild(scrollToTopBtn);
  
  // Control buttons show/hide - Show when scrolling exceeds one screen height
  const screenHeight = window.innerHeight;
  
  window.addEventListener('scroll', function() {
    if (window.scrollY > screenHeight) {
      scrollToTopBtn.classList.add('show');
    } else {
      scrollToTopBtn.classList.remove('show');
    }
  });
  
  // Click the button to smoothly scroll to the top.
  scrollToTopBtn.addEventListener('click', function(e) {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
})();
